import { AutenticacionService } from '../autenticacion.service';
import { Http, URLSearchParams, ResponseContentType } from '@angular/http';
import { ConstantsService } from '../constants.service';
import { Injectable } from '@angular/core';

@Injectable()
export class ReportesfService {

  private service_url : string = '';
  constructor(
    private constantsService: ConstantsService, 
    private http: Http, 
    private authService: AutenticacionService
  ) { 
    this.service_url = this.constantsService.apiURL + '/fondeadores/reportes';
  }

  //Reporte de saldo de fondeos
  public reporte1(filters: any){
    let myParams = new URLSearchParams();

    if(filters.tipoProducto){
      myParams.append('tipo_producto', filters.tipoProducto);
    }

    if(filters.sucursal){
      myParams.append('sucursal', filters.sucursal);
    }

    if(filters.fondeador){
      myParams.append('fondeador', filters.fondeador);
    }

    if(filters.search){
      myParams.append('search', filters.search);
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
    
    let serviceUrl = this.service_url + '/reporte1';
    
    return this.http.get(serviceUrl , myoptions);
  }

  public reporte1ToExcel(filters:any){
    let myParams = new URLSearchParams();
    let myoptions = this.authService.getAuthHeaders();
    if(filters.tipoProducto){
      myParams.append('tipo_producto', filters.tipoProducto);
    }

    if(filters.sucursal){
      myParams.append('sucursal', filters.sucursal);
    }

    if(filters.fondeador){
      myParams.append('fondeador', filters.fondeador);
    }

    if(filters.search){
      myParams.append('search', filters.search);
    }
    myoptions.params = myParams;
    let serviceUrl = this.service_url + '/export01';
    myoptions.responseType = ResponseContentType.Blob;
    return this.http.get(serviceUrl, myoptions);
  }

  //Reporte de rendimeintos a pagar
  public reporte2(filters: any){
    let myParams = new URLSearchParams();

    if(filters.fechaInicio){
      myParams.append('fecha-inicio', filters.fechaInicio);
    }

    if(filters.fechaFin){
      myParams.append('fecha-fin', filters.fechaFin);
    }

    if(filters.tipoProducto){
      myParams.append('tipo_producto', filters.tipoProducto);
    }

    if(filters.sucursal){
      myParams.append('sucursal', filters.sucursal);
    }

    if(filters.search){
      myParams.append('search', filters.search);
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
    
    let serviceUrl = this.service_url + '/reporte2';
    
    return this.http.get(serviceUrl , myoptions);
  }

  public reporte2ToExcel(filters:any){
    let myParams = new URLSearchParams();
    let myoptions = this.authService.getAuthHeaders();
    if(filters.fechaInicio){
      myParams.append('fecha-inicio', filters.fechaInicio);
    }

    if(filters.fechaFin){
      myParams.append('fecha-fin', filters.fechaFin);
    }

    if(filters.tipoProducto){
      myParams.append('tipo_producto', filters.tipoProducto);
    }

    if(filters.sucursal){
      myParams.append('sucursal', filters.sucursal);
    }

    if(filters.search){
      myParams.append('search', filters.search);
    }
    myoptions.params = myParams;
    let serviceUrl = this.service_url + '/export02';
    myoptions.responseType = ResponseContentType.Blob;
    return this.http.get(serviceUrl, myoptions);
  }

  //Reporte de rendimeintos pagados
  public reporte3(filters: any){
    let myParams = new URLSearchParams();

    if(filters.fechaInicio){
      myParams.append('fecha-inicio', filters.fechaInicio);
    }

    if(filters.fechaFin){
      myParams.append('fecha-fin', filters.fechaFin);
    }

    if(filters.tipoProducto){
      myParams.append('tipo_producto', filters.tipoProducto);
    }

    if(filters.sucursal){
      myParams.append('sucursal', filters.sucursal);
    }

    if(filters.search){
      myParams.append('search', filters.search);
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
    
    let serviceUrl = this.service_url + '/reporte3';
    
    return this.http.get(serviceUrl , myoptions);
  }

  public reporte3ToExcel(filters:any){
    let myParams = new URLSearchParams();
    let myoptions = this.authService.getAuthHeaders();
    if(filters.fechaInicio){
      myParams.append('fecha-inicio', filters.fechaInicio);
    }

    if(filters.fechaFin){
      myParams.append('fecha-fin', filters.fechaFin);
    }

    if(filters.tipoProducto){
      myParams.append('tipo_producto', filters.tipoProducto);
    }

    if(filters.sucursal){
      myParams.append('sucursal', filters.sucursal);
    }

    if(filters.search){
      myParams.append('search', filters.search);
    }
    myoptions.params = myParams;
    let serviceUrl = this.service_url + '/export03';
    myoptions.responseType = ResponseContentType.Blob;
    return this.http.get(serviceUrl, myoptions);
  }

  //Reporte de Fondeos
  public reporte4(filters: any){
    let myParams = new URLSearchParams();

    if(filters.fechaInicio){
      myParams.append('fecha-inicio', filters.fechaInicio);
    }

    if(filters.fechaFin){
      myParams.append('fecha-fin', filters.fechaFin);
    }

    if(filters.tipoProducto){
      myParams.append('tipo_producto', filters.tipoProducto);
    }

    if(filters.sucursal){
      myParams.append('sucursal', filters.sucursal);
    }
    if(filters.completado){
      myParams.append('completado', filters.completado);
    }

    if(filters.search){
      myParams.append('search', filters.search);
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
    
    let serviceUrl = this.service_url + '/reporte4';
    
    return this.http.get(serviceUrl , myoptions);
  }

  public reporte4ToExcel(filters:any){
    let myParams = new URLSearchParams();
    let myoptions = this.authService.getAuthHeaders();
    if(filters.fechaInicio){
      myParams.append('fecha-inicio', filters.fechaInicio);
    }

    if(filters.fechaFin){
      myParams.append('fecha-fin', filters.fechaFin);
    }

    if(filters.tipoProducto){
      myParams.append('tipo_producto', filters.tipoProducto);
    }

    if(filters.sucursal){
      myParams.append('sucursal', filters.sucursal);
    }
    if(filters.completado){
      myParams.append('completado', filters.completado);
    }

    if(filters.search){
      myParams.append('search', filters.search);
    }

    myoptions.params = myParams;
    let serviceUrl = this.service_url + '/export04';
    myoptions.responseType = ResponseContentType.Blob;
    return this.http.get(serviceUrl, myoptions);
  }

  //Reporte de devoluciones de fondeos
  public reporte5(filters: any){
    let myParams = new URLSearchParams();

    if(filters.fechaInicio){
      myParams.append('fecha-inicio', filters.fechaInicio);
    }

    if(filters.fechaFin){
      myParams.append('fecha-fin', filters.fechaFin);
    }

    if(filters.tipoProducto){
      myParams.append('tipo_producto', filters.tipoProducto);
    }

    if(filters.sucursal){
      myParams.append('sucursal', filters.sucursal);
    }

    if(filters.search){
      myParams.append('search', filters.search);
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
    
    let serviceUrl = this.service_url + '/reporte5';
    
    return this.http.get(serviceUrl , myoptions);
  }

  public reporte5ToExcel(filters:any){
    let myParams = new URLSearchParams();
    let myoptions = this.authService.getAuthHeaders();
    if(filters.fechaInicio){
      myParams.append('fecha-inicio', filters.fechaInicio);
    }

    if(filters.fechaFin){
      myParams.append('fecha-fin', filters.fechaFin);
    }

    if(filters.tipoProducto){
      myParams.append('tipo_producto', filters.tipoProducto);
    }

    if(filters.sucursal){
      myParams.append('sucursal', filters.sucursal);
    }

    if(filters.search){
      myParams.append('search', filters.search);
    }

    myoptions.params = myParams;
    let serviceUrl = this.service_url + '/export05';
    myoptions.responseType = ResponseContentType.Blob;
    return this.http.get(serviceUrl, myoptions);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/fondeadores-reportes/reportesf.service.ts